<div class="detail-page__body">
  <app-quick-nav class="detail-page__nav" [toc]="toc"></app-quick-nav>
  <app-airport-alert [airport]="airport"></app-airport-alert>
  <div class="detail-page__content">
    <div class="detail-page__primary">
      <div id="overview" class="detail-page__wrapper scroll-spy-section">
        <div class="overview">
          <div class="overview__main">
            <app-overview-header [airport]="airport"></app-overview-header>
          </div>
        </div>
      </div>

      <div class="detail-page__main">
        <div id="activities" class="detail-page__wrapper scroll-spy-section">
          <div class="section">
            <div class="section__body">
              <app-activity-panel [airport]="airport"></app-activity-panel>
            </div>
          </div>
        </div>

        <div id="reviews" class="detail-page__wrapper scroll-spy-section">
          <div class="section">
            <div class="section__header">
              <h2 class="section__header-text">Airport Reviews</h2>
            </div>
            <div class="section__body">
              <app-reviews [airport]="airport" [business]=null></app-reviews>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="detail-page__rail">
      <div class="detail-page__rail-content">
        <div class="section">
          <div class="section__header">
            <h2 class="section__header-text">Aircraft &amp; Activity</h2>
          </div>
          <div class="section__body">
            <app-airport-activity [activity]="airport.activity"></app-airport-activity>
          </div>
        </div>

        <app-open-x-adunit [adUnitId]="'/21794231495/directory/leaderboard'" [width]="300" [height]="600"></app-open-x-adunit>
      </div>
    </div>
  </div>
</div>
